import React from "react";
import { Link } from "react-router-dom";

function Navbar() {
  return (
    <nav className="navbar">
      <div className="container">
        <Link to="/" className="navbar-brand">
          <img src="/file.svg" alt="Logo" className="navbar-logo" />
          DramaQwizz
        </Link>
        <ul className="navbar-nav">
          <li className="nav-item"></li>
          <li className="nav-item">
            <Link to="/about" className="nav-link">
              About  
            </Link>
            </li>
            <li className="nav-item">
            <Link to="/review" className="nav-link">
                 Review
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
